<div class="p-0">
  <div class="m-t-20">
    <div class="row">

      <div class="col-lg-12">

        <mat-card *ngIf="note20" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Expenditure on raising funds
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="data" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total expenditure on raising funds</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center b-r-1">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="UnrestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="RestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="EndowmentLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="TotalLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="ThisYear">
                          <th mat-header-cell *matHeaderCellDef colspan="4" class="border1" style="background: #f7f7f7;">This Year (&pound;)</th>
                        </ng-container>
                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="4" style="background: #f7f7f7;"> Last Year (&pound;) </th>
                        </ng-container>

                        <!--Start Footer Row for Statement of Financial Activities Value (SOFA)-->
                        <ng-container matColumnDef="AnalysisFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="UnrestrictedFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="RestrictedFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="EndowmentFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="TotalFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="UnrestrictedLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="RestrictedLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="EndowmentLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="TotalLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Statement of Financial Activities Value (SOFA)-->

                        <!--Start Footer Row for Difference-->
                        <ng-container matColumnDef="AnalysisDiffFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            Difference
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="UnrestrictedDiffFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="RestrictedDiffFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="EndowmentDiffFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="TotalDiffFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="UnrestrictedDiffLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="RestrictedDiffLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="EndowmentDiffLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="TotalDiffLastYearFooter">
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Difference-->

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky :true" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="secondaryFooterDisplayedColumns; sticky :true" style="background: #f3f3f3;"></tr>
                        <tr mat-footer-row *matFooterRowDef="thirdFooterDisplayedColumns; sticky :true" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note21" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Expenditure on charitable activities
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="data2" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14" style="text-wrap: pretty;">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600" style="text-wrap: pretty;">Total expenditure on charitable activities</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="UnrestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="RestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="EndowmentLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="TotalLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="ThisYear">
                          <th mat-header-cell *matHeaderCellDef colspan="4" class="border1" style="background: #f7f7f7;">This Year (&pound;)</th>
                        </ng-container>
                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="4" style="background: #f7f7f7;"> Last Year (&pound;) </th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns2; sticky :true" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note22" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Separate material item of expense
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="data3" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14" style="text-wrap: pretty;">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600" style="text-wrap: pretty;">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="UnrestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="RestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="EndowmentLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="TotalLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="ThisYear">
                          <th mat-header-cell *matHeaderCellDef colspan="4" class="border1" style="background: #f7f7f7;">This Year (&pound;)</th>
                        </ng-container>
                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="4" style="background: #f7f7f7;"> Last Year (&pound;) </th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns3" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns3; sticky :true" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note23" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Other Expenditure
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="data4" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14" style="text-wrap: pretty;">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600" style="text-wrap: pretty;">Total Other Expenditure</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="UnrestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="RestrictedLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Restricted  funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="EndowmentLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="TotalLastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total funds
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 cus-width-td">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="9" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="ThisYear">
                          <th mat-header-cell *matHeaderCellDef colspan="4" class="border1" style="background: #f7f7f7;">This Year (&pound;)</th>
                        </ng-container>
                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="4" style="background: #f7f7f7;"> Last Year (&pound;) </th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns4" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns4"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns4; sticky :true" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-card class="b-0">
          <mat-card-content class="p-0">

            <div class="row p-16">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button color="primary" class="bg-warning text-end" (click)="BackNote()">
                  <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">
                <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveandNextNote(null,true)">
                  <!--<button mat-flat-button color="primary" class="bg-success rounded-5"  (click)="emitClickEvent('note11')">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                  </div>
                </button>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>
</div>
